import Shepherd from 'shepherd.js';

if($('.application-vetting-page').length && $('.application-draft').length){
    
    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'vetting'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    if($(window).width() < 992){
        var attachTo = {
            element: '.dashboard-title-wrapper .dashboard-sidebar-toggle',
            on: 'bottom'
        }
    }else{
        var attachTo = {
            element: '.dashboard--sidebar .nav--dashboard ul',
            on: 'right'
        }
    }
    
    tour.addStep({
        title: 'Vetting',
        text: "On this page you may be asked some additional compulsory vetting questions related to your application. You will be asked to add an optional cover note which will strengthen your application. If you are applying with an innovation you will also be able to request an Non Disclosure Agreement ( Non Disclosure Agreement ).",
        // attachTo: {
        //     element: '.dashboard--overview',
        //     on: 'bottom-start'
        // },
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: "Finished? Move onto Review",
        text: "Once you've finished with your application, you can move forward to save and review before submitting it to the Challenge. It will still be in draft and won't be submitted to the Challenge until you click 'Submit' on the next page.",
        attachTo: {
            element: '.application-vetting-page .actions-row .btn',
            on: 'top'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    window.scrollTo(0, 0);
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: "Let's start!",
        text: "Click 'Finish' to fill in the vetting and continue your application.",
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-3'
    });

    $('.replay-onboarding').show();

    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if($('.application-vetting-page').length && $('.application-draft').length && !$('.onboarding-vetting').length){
        tour.start();
    }
}
